import store from "../../../store"
import { useSelector } from "react-redux"
export const getScheduleSelection = (isTomorrowMode, sandbox) => {
	if (isTomorrowMode) {
		return "tomorrow"
	} else if (sandbox) {
		return "sandbox"
	} else {
		return "today"
	}
}
export const scheduleSelect = ({
	scheduleSelection,
	todayOption,
	tomorrowOption,
	sandboxOption
}) => {
	if (scheduleSelection === "today") {
		return todayOption
	} else if (scheduleSelection === "tomorrow") {
		return tomorrowOption
	} else {
		return sandboxOption
	}
}

export const getScheduleForSelection = scheduleSelection => {
	const state = store.getState()
	if (scheduleSelection === "today") {
		return state.schedule
	} else if (scheduleSelection === "tomorrow") {
		return state.tomorrow
	} else {
		return state.sandbox
	}
}

export const useScheduleForSelection = scheduleSelection => {
	const schedule = useSelector(state => state.schedule)
	const tomorrowSchedule = useSelector(state => state.tomorrow)
	const sandbox = useSelector(state => state.sandbox)

	if (scheduleSelection === "today") {
		return schedule
	} else if (scheduleSelection === "tomorrow") {
		return tomorrowSchedule
	} else {
		return sandbox
	}
}
